"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listeKapilariSchema = exports.KAPI_ACIK = exports.kapiDurumuSchema = exports.silinenEkSchema = exports.ekSilmeGovdesiSchema = exports.yazamamaSebebiSchema = exports.YAZAMAMA_SEBEP_KODLARI = void 0;
exports.ilkKapaliKapi = ilkKapaliKapi;
const zod_1 = require("zod");
const shared_types_1 = require("@isg/shared-types");
/**
 * KAPI DURUMU — YAZAMAYAN KULLANICININ SEBEBİ (yüzey dürüstlüğü turu · ikinci
 * oturum, madde 219; Kapsam §20.3b P13 · CLAUDE.md §2.40).
 *
 * ════════════════════════════════════════════════════════════════════════
 * TEK CÜMLE: BAYRAK VE SEBEP KAPININ ADIMLARINDAN OKUNUR
 * ════════════════════════════════════════════════════════════════════════
 *
 * Her yazma kapısı sıralı bir adım listesidir — **şapka** (sabit ya da tenant
 * listesi) → **bahçe** → **arşiv** → **durum**. Sunucu listeyi zorlar; kaydın
 * yanıtı AYNI listeyi değerlendirir ve ilk düşen adımı sebep olarak döner
 * (`apps/api/src/authorization/kapi-durumu.ts`). Ekran bu nesneden çizer.
 *
 * ⚠️ **NEDEN:** B envanteri altı bölümde ekran bayrağının kapıdan AYRI
 * kaynaktan hesaplandığını buldu — saha sorumlusu açabildiği tatbikatın
 * düğmesini görmüyordu, bahçe dışı kullanıcı DÖF düğmesini görüp 403
 * alıyordu. Sebep hizalamadan önce yazılsaydı yanlış sebep yazılırdı.
 *
 * ⚠️ **ŞAPKA LİSTESİ BU NESNEDE TAŞINIR:** tenant ayarına bağlı kapılarda
 * (olay · sağlık · eğitim · risk · uygunsuzluk) liste tenant'a göre değişir ve
 * istemciye gömülemez. Şapka ADLARI i18n'dendir (enum'a Türkçe metin girmez).
 *
 * ⚠️ **`durum` sebebinin metni KAPININ KENDİ CÜMLESİDİR** (D2 dili — sunucunun
 * reddettiği metnin aynısı); ekran ikinci bir cümle yazmaz.
 */
/**
 * ✏️ **P13-c (yüzey dürüstlüğü artçısı, 12.09.2026 — madde 227):** beşinci kod
 * `sahiplik` — *"yalnız yükleyen ya da holding yöneticisi"* satır eylemi. Ek
 * silme kapısı bir adım listesidir (şapka → bahçe → arşiv → **durum: kapalı
 * kayıt** → **sahiplik**); yazamayanın sebebi bölüm başına BİR KEZ yazılır.
 */
/**
 * ✏️ **PTW ONAY DÜĞMESİ (14.09.2026 — K-63; Kapsam §16.7 ✏️ · §20.3b P13-d):**
 * altıncı kod `elle_bahce` — onay havuzu yalnız ELLE verilmiş bahçeyi okur
 * (tur 10 / S1); türetilen bahçesiyle izni GÖREN kullanıcıya genel
 * *"bahçenizde değil"* cümlesi yalan söylerdi. Sebep ekranda *"Bu işyeri elle
 * verilmiş bahçenizde değil."* olur.
 */
exports.YAZAMAMA_SEBEP_KODLARI = [
    'sapka',
    'bahce',
    'elle_bahce',
    'arsiv',
    'durum',
    'sahiplik',
];
exports.yazamamaSebebiSchema = zod_1.z.discriminatedUnion('kod', [
    zod_1.z.object({ kod: zod_1.z.literal('sapka'), sapkalar: zod_1.z.array(zod_1.z.enum(shared_types_1.ROLE_TYPES)).min(1) }),
    zod_1.z.object({ kod: zod_1.z.literal('bahce') }),
    zod_1.z.object({ kod: zod_1.z.literal('elle_bahce') }),
    zod_1.z.object({ kod: zod_1.z.literal('arsiv') }),
    zod_1.z.object({ kod: zod_1.z.literal('durum'), metin: zod_1.z.string().min(1) }),
    zod_1.z.object({ kod: zod_1.z.literal('sahiplik') }),
]);
/**
 * KAPALI KAYITTA EK SİLME — DAR İSTİSNA (KÜÇÜK PAKET, 13.09.2026 — madde 230;
 * Kapsam §20.3b P13-c ✏️). Kapalı kayıtta eki yalnız holding yöneticisi siler
 * ve GEREKÇE ZORUNLUDUR; açık kayıtta gerekçe isteğe bağlıdır. Gövde DELETE
 * isteğinin JSON'udur (boş gövde = gerekçesiz).
 */
exports.ekSilmeGovdesiSchema = zod_1.z.object({
    gerekce: zod_1.z.string().trim().min(3).max(500).optional(),
});
/**
 * KALDIRILAN EK — silmenin izi silinen satırın kendisidir (ERD §10g · §10h:
 * `silen_app_user_id` · `deleted_at` · `silme_gerekcesi`); detay yanıtı bunu
 * "kaldırılan ekler" listesi olarak taşır (kim · ne zaman · gerekçe).
 */
exports.silinenEkSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    dosyaAdi: zod_1.z.string().min(1),
    silenEtiket: zod_1.z.string().nullable(),
    gerekce: zod_1.z.string().nullable(),
    silindiAt: zod_1.z.iso.datetime(),
});
/**
 * Yanıttaki `…Kapisi` alanlarının TEK biçimi. `yazabilir` ile `sebep` birbirini
 * tutmak zorundadır — yazabilen kullanıcıya sebep taşınmaz, yazamayana sebepsiz
 * `false` taşınmaz (sebepsiz boşluk §2.40'ın sunum koludur).
 */
exports.kapiDurumuSchema = zod_1.z
    .object({ yazabilir: zod_1.z.boolean(), sebep: exports.yazamamaSebebiSchema.nullable() })
    .refine((d) => d.yazabilir === (d.sebep === null), {
    message: 'Kapı durumu tutarsız: yazabilir ⇔ sebep yok',
});
/** Sunucu yardımcısının dışında kurulamaz; testler ve varsayılanlar için tek sabit. */
exports.KAPI_ACIK = { yazabilir: true, sebep: null };
/**
 * BÖLÜM BAŞINA TEK SEBEP (P13-c): satır kapılarının İLK kapalısı. Yazabilen
 * satır varsa yazamayanın sebebi yine yazılır (kullanıcı kendi ekini silebilir,
 * başkasınınkini silemez — ikisini de görür); hiç kapalı satır yoksa `null`.
 */
function ilkKapaliKapi(kapilar) {
    return kapilar.find((k) => !k.yazabilir) ?? null;
}
/**
 * LİSTE DÜZEYİ KAPILAR — `GET kapilar` (P13-b, yüzey dürüstlüğü artçısı
 * 12.09.2026 — madde 225; Kapsam §20.3b). Kaydı olmayan görünürlük koşulları
 * (*"Yeni aksiyon"* · *"Şirket ekle"* · *"Toplu yükle"* · liste ekranlarının
 * ekleme satırları · kişi kartının bölüm başlıkları) bir kaydın `…Kapisi`
 * alanına asılamaz; bunlar TEK uçtan okunur. Her alan ilgili yazma ucunun
 * KENDİ şapka sabitinden (`modul-rolleri.ts`) ve varsa tenant anahtarından
 * `kapiDurumu` ile türetilir; bahçe adımı hedef seçilince kaydın kendi
 * kapısında koşar. Ekranda şapka dizgesi KALMADI — envanter boş listeyle kilitli.
 */
exports.listeKapilariSchema = zod_1.z.object({
    // organizasyon
    sirketKapisi: exports.kapiDurumuSchema,
    isyeriKapisi: exports.kapiDurumuSchema,
    arsivKapisi: exports.kapiDurumuSchema,
    // çalışanlar
    kisiKapisi: exports.kapiDurumuSchema,
    kisiYuklemeKapisi: exports.kapiDurumuSchema,
    yetkinlikKapisi: exports.kapiDurumuSchema,
    kimlikGosterimKapisi: exports.kapiDurumuSchema,
    hesapDiziniKapisi: exports.kapiDurumuSchema,
    yukleniciDiziniKapisi: exports.kapiDurumuSchema,
    sapkaVermeKapisi: exports.kapiDurumuSchema,
    gorevlendirmeKapisi: exports.kapiDurumuSchema,
    // modüller
    aksiyonKapisi: exports.kapiDurumuSchema,
    aksiyonAyarKapisi: exports.kapiDurumuSchema,
    aksiyonDevirKapisi: exports.kapiDurumuSchema,
    egitimYuklemeKapisi: exports.kapiDurumuSchema,
    ekipmanKapisi: exports.kapiDurumuSchema,
    ekipmanYuklemeKapisi: exports.kapiDurumuSchema,
    sablonKapisi: exports.kapiDurumuSchema,
    formDoldurmaKapisi: exports.kapiDurumuSchema,
    izinTalepKapisi: exports.kapiDurumuSchema,
    sozlukKapisi: exports.kapiDurumuSchema,
    sozlukNushaKapisi: exports.kapiDurumuSchema,
    uygunsuzlukBildirimKapisi: exports.kapiDurumuSchema,
    yukleniciKapisi: exports.kapiDurumuSchema,
    /** K-102j — evrak paketi tanımlama (yalnız holding yön.). */
    evrakPaketiKapisi: exports.kapiDurumuSchema,
    yukumlulukKutuphaneKapisi: exports.kapiDurumuSchema,
    yukumlulukGizlemeKapisi: exports.kapiDurumuSchema,
    yukumlulukIsaretKapisi: exports.kapiDurumuSchema,
    /**
     * İKİNCİL OKUMA (sessiz 403 paketi, 29.09.2026 — madde 283): ekran bu parçayı
     * ÇAĞIRSIN MI ve ÇİZSİN Mİ — ikisi aynı cevap. Her bayrak ilgili okuma ucunun
     * kendi sabitinden (`ikincil-okuma.ts`).
     *
     * ⚠️ **KAPI DEĞİL, BAYRAKTIR** ve bu yüzden `…Kapisi` adını taşımaz: kapı
     * *"yazamayan sebebini görür"* sözleşmesidir (P13); buradaki karar *"parça o
     * şapkaya hiç çizilmez"*dir — sebep satırı yazılmaz.
     */
    ikincilOkuma: zod_1.z.object({
        gorevListesi: zod_1.z.boolean(),
        gecikmisGorev: zod_1.z.boolean(),
        zorunluGorevlendirme: zod_1.z.boolean(),
        atanabilir: zod_1.z.boolean(),
        katilimciKarari: zod_1.z.boolean(),
        /** Kişi kartı: görevlendirme bölümü (madde 291). */
        gorevlendirme: zod_1.z.boolean(),
        /**
         * Kişi kartı: uygunluk paneli — ŞAPKA kolu (madde 295). Çalışanın KENDİ
         * kartı bu bayraktan değil kimlikten çözülür (`my-authorization.personId`);
         * ikisini `uygunlukPaneliErisimi` birleştirir.
         */
        uygunlukPaneli: zod_1.z.boolean(),
        /**
         * Kişi kartı: hekim kanaati + çalışma profili (madde 291). ⚠️ **SAĞLIK
         * KURALI:** sağlık ucu, sağlık okuma listesinde olmayan şapkada ASLA
         * çağrılmaz — bayrak `SAGLIK_OKUMA_SAPKALARI`nın kendisinden.
         */
        saglikKanaati: zod_1.z.boolean(),
    }),
});
//# sourceMappingURL=kapi-durumu.js.map